import { Box, Flex, Link, Typography } from '@iheartjane/reefer';
import { useMemo, useState } from 'react';

import { TerpeneBar } from '@jane/shared-ecomm/components';
import type { LabResult, TerpeneEnum } from '@jane/shared/types';

import { useKioskSpacing } from '../../../hooks';

interface TerpeneSectionProps {
  sortedTerpenes: (LabResult['lab_results'][number] & {
    matchingTerpene: TerpeneEnum;
  })[];
}

export const TerpeneSection = ({ sortedTerpenes }: TerpeneSectionProps) => {
  const [viewMore, setViewMore] = useState(false);
  const { defaultSpacing, getKioskSpacing } = useKioskSpacing();

  const total = useMemo(
    () =>
      (!viewMore ? sortedTerpenes.slice(0, 3) : sortedTerpenes).reduce(
        (prev, curr) => prev + curr.value,
        0
      ),
    [sortedTerpenes, viewMore]
  );

  return (
    <Box
      border="transparent-black-five"
      borderRadius="lg"
      p={defaultSpacing}
      ariaLabel="product terpenes section"
      mb={24}
    >
      <Flex
        mb={getKioskSpacing(24, 8)}
        justifyContent="space-between"
        width="100%"
        alignItems="center"
      >
        <Typography variant="body-bold">Top terpenes</Typography>
        <Link onClick={() => setViewMore(!viewMore)}>
          <Typography variant="body">
            View {viewMore ? 'less' : 'more'}
          </Typography>
        </Link>
      </Flex>
      <Flex
        flexDirection={!viewMore ? 'row' : 'column'}
        flexWrap="nowrap"
        width="100%"
        gap={16}
        mt={16}
      >
        {(viewMore ? sortedTerpenes : sortedTerpenes.slice(0, 3)).map(
          (terpene) => (
            <TerpeneBar
              actualPercentage={terpene.value}
              variant={viewMore ? 'row' : 'column'}
              key={terpene.matchingTerpene}
              widthPercentage={(terpene.value / total) * 100}
              terpene={terpene.matchingTerpene}
              terpeneNameMt={8}
              typography={Typography}
              unit={terpene.unit}
            />
          )
        )}
      </Flex>
    </Box>
  );
};
